import ServiceCategoryPage from "../components/ServiceCategoryPage";
import homeTutorService from "../data/services/homeTutorService";

function HomeTutor() {
  return <ServiceCategoryPage service={homeTutorService} />;
}

export default HomeTutor;